import React from 'react';
import { Modal } from '@gerdau/hefesto';

import { ModalOverlay } from './styles';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loadUpdateOrderItems } from '../../../../store/ducks/new-long-steel-orders/actions';
import { StateProps } from '../OrderUpdate';
import { ECustomerTypeView } from '../../../../store/ducks/user/types';
import { IUpdateOrderRequest } from '../../../../store/ducks/new-long-steel-orders/types';
import { updateQueryParam } from '../../../../utils/updateQueryParams';

export const UpdateItemsConfirm = ({ data }: { data: StateProps[] }) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const pending = params.get('changes') === 'pending';

  if (!pending) {
    return null;
  }

  const dispatch = useDispatch();

  const handleClose = () => {
    return updateQueryParam('changes');
  };

  const handleConfirm = () => {
    const bodyToUpdate: IUpdateOrderRequest[] = data.map((obj) => ({
      customer: obj.item.soldTo.code,
      customerType: ECustomerTypeView.EMITTER,
      salesOrder: obj.item.salesOrder.toString(),
      salesOrderItem: obj.item.salesOrderItem.toString(),
      ...(obj.checkbox.quantity &&
        obj.values.quantity &&
        obj.item.quantities.requestedMeasureUnit && {
          unityMeasure: obj.item.quantities.requestedMeasureUnit,
          quantity: obj.values.quantity
        }),
      ...(obj.checkbox.desiredDate &&
        obj.values.desiredDate && {
          requiredDate: obj.values.desiredDate
        }),
      ...(obj.checkbox.other &&
        obj.values.other && {
          editMessage: obj.values.other
        })
    }));

    dispatch(
      loadUpdateOrderItems({
        itemsToUpdate: bodyToUpdate,
        typeAction: 'update',
        itemsSelected: data.map((obj) => obj.item)
      })
    );
  };

  return (
    <ModalOverlay width={564}>
      <Modal
        title={`Solicitar alterações em ${data.length} ite${
          data.length > 1 ? 'ns' : 'm'
        }`}
        modalSize="md"
        buttons={{
          left: {
            name: 'button-close-items-update-confirm',
            children: 'Cancelar',
            onClick: handleClose,
            type: 'button'
          },
          right: {
            name: 'button-continue-items-update-confirm',
            children: 'Solicitar alterações',
            onClick: handleConfirm,
            type: 'button'
          }
        }}
      >
        <span>
          Sua solicitação de alteração será analisada e respondida em até 3 dias
          úteis. Deseja solicitar alterações?
        </span>
      </Modal>
    </ModalOverlay>
  );
};
